import styled from 'styled-components';

export const SystemDetailsContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex: 1;
`;
